import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=89f73936&scoped=true"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=89f73936&prod&lang=scss&scoped=true"
import style1 from "./HospitalList.vue?vue&type=style&index=1&id=89f73936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f73936",
  null
  
)

export default component.exports